/**
 * IMAYO 商品カードインタラクションJS
 * - 画像エリアクリックで商品ページへ遷移
 * - 素材チップクリックでカード全体のリンク先を切り替え
 */
(function () {
  // 複数セクションから読み込まれてもリスナーは1つだけ登録する
  if (window.__imayoMaterialSelectorInit) return;
  window.__imayoMaterialSelectorInit = true;
  function init() {
    document.addEventListener("click", function (e) {
      // 素材チップの処理
      var chip = e.target.closest(".material-chips__item");
      if (chip) {
        handleChipClick(chip);
        return;
      }

      // 画像エリアのクリック→商品リンクへ遷移
      var slideImg = e.target.closest(".slide-img");
      if (!slideImg) return;
      if (e.target.closest(".slide-arrow, .slide-fav, .c-fav-btn")) return;
      var card = slideImg.closest(".c-slide");
      if (!card) return;
      var link = card.querySelector(".slide-link");
      if (link) {
        window.location.href = link.href;
      }
    });
  }

  function handleChipClick(chip) {
    var card = chip.closest(".c-slide");
    if (!card) return;
    var variantUrl = chip.dataset.variantUrl;
    if (!variantUrl) return;
    // アクティブ状態を切り替え
    var siblings = chip.closest(".material-chips").querySelectorAll(".material-chips__item");
    siblings.forEach(function (s) {
      s.classList.remove("-active");
    });
    chip.classList.add("-active");
    // カード内の全リンクを更新
    var links = card.querySelectorAll("a");
    links.forEach(function (link) {
      link.href = variantUrl;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
